// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_1a-2";
export var blackBorderOnHover = "_1a-7";
export var cell = "_1a-6";
export var cellContainer = "_1a-3";
export var checked = "_1a-8";
export var disabled = "_1a-5";
export var featuredIconCellContainer = "_1a-9";
export var featuredIconTextContainer = "_1a-b";
export var featuredIconWrapper = "_1a-a";
export var noBorder = "_1a-c";
export var orangeSelectedRow = "_4b-3";
export var overflowableText = "_1a-0";
export var overflowableTextContainer = "_1a-1";
export var row = "_1b-0";
export var rowCheckboxCell = "_1a-4";
export var selectableTable = "_4b-2";